import { useEffect, useState } from 'react';
const KEY = 'standard-cookie-consent-v4';
const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
let sessionChoice = null;
export function readConsent() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (value?.version === 4 && Number.isFinite(value.savedAt) && Date.now() - value.savedAt < MAX_AGE && value.savedAt <= Date.now()) return value;
    return null;
  } catch {}
  return sessionChoice && Date.now() - sessionChoice.savedAt < MAX_AGE ? sessionChoice : null;
}
export function saveConsent(choice) {
  const value = { version: 4, savedAt: Date.now(), necessary: true, advertising: Boolean(choice.advertising), analytics: Boolean(choice.analytics), measurement: Boolean(choice.measurement), media: Boolean(choice.media) };
  sessionChoice = value;
  try { localStorage.setItem(KEY, JSON.stringify(value)); } catch {}
  window.dispatchEvent(new CustomEvent('standard-consent-change', { detail: value }));
  return value;
}
export const openCookiePreferences = () => window.dispatchEvent(new Event('standard-cookie-preferences'));
export function useConsent() {
  const [choice, setChoice] = useState(readConsent);
  useEffect(() => {
    const refresh = () => setChoice(readConsent());
    window.addEventListener('standard-consent-change', refresh);
    window.addEventListener('storage', refresh);
    return () => { window.removeEventListener('standard-consent-change', refresh); window.removeEventListener('storage', refresh); };
  }, []);
  return choice;
}
